import { withCdn } from './withCdn'

export const fetchStringToFile = async (
  fileName: string,
  fileType: string,
  fileUrl?: string,
): Promise<File> => {
  try {
    const url = fileUrl ?? withCdn(fileName)
    const response = await fetch(url)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()

    if (blob.size === 0) {
      throw new Error('Retrieved file is empty')
    }

    return new File([blob], fileName, { type: fileType })
  } catch (error) {
    console.error('Error fetching file:', error)
    throw error
  }
}
